import { PRODUCT_DATA } from "../constants/action-types";
import { uploadActions } from "./base-upload-reducers";
import { progressActions } from "./base-reducers";
import { handleActions } from "redux-actions";
import { FileExport } from "../records/files";

export interface IExportState {
    isExporting: boolean;
    isArchiving: boolean;
    payload: FileExport | null;
    errors: string[];
}

export const productDataUpload = uploadActions(PRODUCT_DATA);
export const productDataExport = handleActions(
    {
        ...progressActions(PRODUCT_DATA.EXPORT.DOWNLOAD, "isExporting"),
        [PRODUCT_DATA.EXPORT.RESET]: (state) => ({ ...state, payload: null }),
    } as any,
    { isExporting: false, errors: null, payload: null },
);

export const productDataArchive = progressActions(PRODUCT_DATA.ARCHIVE, "isArchiving");
